import { render, staticRenderFns } from "./WidgetProductReviewsGalleryMobile.vue?vue&type=template&id=26e71140"
import script from "./WidgetProductReviewsGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports